<template>
    <div id="page">

        <div class="page-content">
            <div class="fixed-top-box">
                <div class="page-title page-title-small">
                    <h2>
                        <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                        زمان سنج (تایمر)
                        <!--<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>-->
                    </h2>
                    <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                    <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
                </div>
                <div class="card header-card shape-rounded" data-card-height="100">
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                </div>
                <div class="card card-style mb-2">
                    <div class="p-3 d-flex">
                        <button id="filterBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#searchModal" style="max-height:31px!important">
                            <i class="fa fa-filter text-white"></i>
                        </button>
                        <div class="filter-row-scrollable">
                            <div @click="lstFilter('Doing',1)" id="Doing" class="filterSelectItem filter-scrollable-box selected">در حال انجام</div>
                            <div @click="lstFilter('Ending',2)" id="Ending" class="filterSelectItem filter-scrollable-box">پایان یافته</div>
                            <div @click="lstFilter('All',3)" id="All" class="filterSelectItem filter-scrollable-box">همه</div>

                        </div>
                    </div>
                </div>
            </div>
            <span data-menu="menu-language" class="optionMenu"></span>
            <div class="main-content-box">
                <div :class="{'bg-Start' : item.lastStatus ,'bg-Regist' : item.regist}" class="verticalListCol" v-for="item in WorkTimerList" :key="item.id">
                    <div class="timerTitel d-flex justify-content-between rounded-sm font-900 p-2 w-100 mb-2 text-white">
                        <span class="font-weight-bold">{{item.title}} ({{item.folderCount}})</span>
                        <span @click.stop="showMenu(item)" class="text-center" style="width:25px"><i class="fa fa-ellipsis-v font-14"></i></span>
                    </div>
                    <ul class="list-group list-group-flush rounded-sm">
                        <li class="list-group-item p-2">
                            تاریخ ایجاد: <b class="d-inline-block text-left ltr float-left">{{item.createDateFa}}</b>
                        </li>
                        <li v-if="item.lastUpdateDateTimeFa!=null" class="list-group-item p-2">
                            زمان ثبت آخرین تغییرات:<b class="d-inline-block text-left ltr float-left"> {{item.lastUpdateDateTimeFa}}</b>
                        </li>
                        <li v-if="item.startDateTimeFa!=null" class="list-group-item p-2">
                            زمان شروع:<b class="d-inline-block text-left ltr float-left"> {{item.startDateTimeFa}}</b>
                        </li>
                        <li v-if="item.endDateTimeFa!=null" class="list-group-item p-2">
                            زمان پایان:<b class="d-inline-block text-left ltr float-left"> {{item.endDateTimeFa}}</b>
                        </li>
                        <li v-if="item.workTime!=null" class="list-group-item p-2">
                            زمان استفاده شده:<b class="d-inline-block text-left ltr float-left"> {{item.workTime}}</b>
                        </li>
                        <li v-if="item.lastStatus" class="list-group-item p-2 text-center">
                            {{GetDatediffBetweenTheseTwoTimes(item,true)}}
                            <b class="d-inline-block text-left ltr TimeCunter" id="TimeCunter"></b>
                        </li>
                    </ul>


                    <div v-if="!item.regist">

                        <button v-if="!item.lastStatus" @click="StartTimeWorkTimer(item)" type="button" class="btn btn-xxs mt-2 btn-full bg-warning text-white rounded-sm font-900 w-100"><i class="fa fa-play font-10 ml-2"></i>شروع</button>

                        <button v-else type="button" @click="StopTimeWorkTimer(item)" class="btn btn-xxs mt-2 btn-full bg-red1-dark rounded-sm font-900 w-100"><i class="fa fa-pause font-10 ml-2"></i>توقف</button>

                    </div>
                    <div v-else class="finished-box">
                        <span class="i-bg">
                            <i class="fa fa-hourglass-end"></i>
                        </span>
                        <b class="font-weight-bold">پایان یافته است</b>
                    </div>

                </div>
                <div class="card card-style" v-if="WorkTimerList.length==0 && Loading==false">
                    <div class="content">
                        <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                        <p class="text-center py-3">زمانسنجی یافت نشد.</p>
                    </div>
                </div>
                <div class="card card-style" v-if="Loading==false && NoMoreData==false && WorkTimerList.length>0 && WorkTimerList.length%10==0">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100">
                            <button class="btn btn-outline-info rounded-m" @click="GetNextPage">نمایش بیشتر</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn">
                <router-link to="/CreateTaskNote">
                    <div class="icon icon-m rounded-m color-white bg-green2-light">
                        <i class="fa fa-plus"></i>
                    </div>
                </router-link>
            </div>
        </transition>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading==true" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>درحال دریافت اطلاعات ...</div>
            </div>
        </transition>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn">
                <router-link to="/AddOrEditWorkTimer">
                    <div class="icon icon-m rounded-m color-white bg-green2-light">
                        <i class="fa fa-plus"></i>
                    </div>
                </router-link>
            </div>
        </transition>
        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'AddOrEditWorkTimer', params: { id: itemId  } }" v-if="regist" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-search color-yellow1-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
                    <!--<button v-if="lastFolderId!=null" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-paperclip color-red1-light float-right font-14"></i>افزودن ضمیمه</span><i class="fa fa-angle-left"></i></button>
                    <button v-if="lastFolderId!=null" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-paperclip color-red1-light float-right font-14"></i>ضمائم</span><i class="fa fa-angle-left"></i></button>-->
                    <router-link :to="{ name: 'AddOrEditWorkTimer', params: { id: itemId  } }" v-if="!regist" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-edit color-green2-light float-right font-14"></i>ویرایش</span><i class="fa fa-angle-left"></i></router-link>
                    <button v-if="!regist" class="d-flex justify-content-between align-items-center bg-white p-0" @click="RegistWorkTimer"><span class="d-inline-flex align-items-center"><i class="fa fa-hourglass-end color-blue1-dark float-right font-14"></i>اتمام</span><i class="fa fa-angle-left"></i></button>
                    <button v-if="!regist" class="d-flex justify-content-between align-items-center bg-white p-0" @click="DeleteWorkTimer"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
                    <button v-if="regist && otherWorkId==null" class="d-flex justify-content-between align-items-center bg-white p-0" @click="WorkTimerInsertOtherWork"><span class="d-inline-flex align-items-center"><i class="fa fa-list-alt color-magenta2-light float-right font-14"></i>صدور فعالیت بر مبنای زمان سنج</span><i class="fa fa-angle-left"></i></button>
                </div>
                <div class="clear"></div>
            </div>
        </div>
        <Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
    </div>
    <Create-OtherWork v-if="openCreateOtherWorkModal" v-bind:ItemId="itemId" @close="CloseCreateOtherWorkModal"></Create-OtherWork>

    <div id="searchModal" class="modal fade" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header align-items-center">
                    <h4 class="modal-title mt-0">جستجو</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body m-0">
                    <div class="mb-3">
                        <div class="w-100 search-box rounded-m position-relative">
                            <i class="fa fa-search pr-3"></i>
                            <input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey">
                        </div>
                    </div>

                    <myTeamList txtPlaceholder="کاربران" class="mb-3" @selectUser="selectUser"></myTeamList>

                    <projects class="mb-3" @selectProject="selectProject"></projects>

                    <calendar-filter class="filterCalendar" @selectDate="selectDate"></calendar-filter>
                    <button type="button" class="btn btn-xxs btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal" @click="page=1;filterList()">
                        <i class="fa fa-search ml-2"></i>
                        جستجو
                    </button>
                </div>
            </div>
        </div>
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
            </div>
        </transition>
    </div>

</template>

<script>
    import VueSimpleAlert from "vue3-simple-alert";
    import HelpMenu from '../Components/HelpMenu.vue';
    import CreateOtherWork from '../Components/CreateOtherWork.vue';
    import calendarFilter from '../Components/CalendarFilter.vue';
    import ProjectList from '../Components/ProjectList.vue';
    import MyTeamList from '../Components/MyTeamList.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu,
            "Create-OtherWork": CreateOtherWork,
            "calendar-filter": calendarFilter,
            "projects": ProjectList,
            "myTeamList": MyTeamList,
        },
        data() {
            return {
                openCreateOtherWorkModal: false,
                regist: false,
                filterId: 1,
                searchKey: "",
                lastFolderId: null,
                otherWorkId: null,
                page: 1,
                itemId: 0,
                pageLoaded: false,
                polling: null,
                date: null,
                userId: null,
                projectId: null,
            };
        },
        computed: {
            WorkTimerList() {
                return this.$store.getters.GetWorkTimerList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            NoMoreData() {
                return this.$store.getters.GetWorkTimerNoMoreData;
            },
        },
        beforeRouteLeave(to, from) {
            clearInterval(this.polling)
        },
        created() {
            this.$store.dispatch("GetWorkTimerListFromServer", {
                status: this.filterId,
                page: this.page,
            });
        },
        mounted() {
            this.showAddButton();
            try {
                this.polling = setInterval(function () {
                    let h = 0;
                    let m = 0;
                    let s = 0;
                    let time = [];
                    let t = document.getElementById("TimeCunter");
                    if (t != null) {
                        time = t.innerText.split(":");
                        h = parseInt(time[0])
                        m = parseInt(time[1])
                        s = parseInt(time[2])
                        s = s + 1;
                        if (s >= 60) {
                            s = 0;
                            m = m + 1;
                        }
                        if (m >= 60) {
                            m = 0;
                            h = h + 1;
                        }
                        t.innerText = h.toString().padStart(2, '0') + ":" + m.toString().padStart(2, '0') + ":" + s.toString().padStart(2, '0');
                    } else {
                        clearInterval(this.polling);
                    }
                }, 1000);
            } catch (e) {

                clearInterval(this.polling);
            }
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        },
        activated() {
            this.showAddButton();
        },
        methods: {
            selectDate(d) {
                this.date = d;
                this.page = 0;
            },
            selectProject(d) {
                this.projectId = d;
            },
            selectUser(d) {
                this.userId = d;
            },
            lstFilter(filterSelect, filterId) {
                this.filterId = filterId;
                var elements = document.getElementsByClassName('filterSelectItem');
                for (var i = 0; i < elements.length; i++) {
                    elements[i].classList.remove('selected');
                }
                document.getElementById(filterSelect).classList.add('selected');
                this.page = 1;
                this.filterList();
            },
            GetNextPage() {
                this.page = this.page + 1;
                this.filterList();
            },
            filterList() {
                this.$store.dispatch("GetWorkTimerListFromServer", {
                    status: this.filterId,
                    text: this.searchKey,
                    date: this.date,
                    projectId: this.projectId,
                    userId: this.userId,
                    page: this.page
                });
            },
            CloseCreateOtherWorkModal() {
                this.openCreateOtherWorkModal = false;
            },
            showAddButton() {
                this.pageLoaded = true;

            },
            showMenu(item) {
                this.regist = item.regist;
                this.otherWorkId = item.otherWorkId;
                this.itemId = item.id;
                this.lastFolderId = item.lastFolderId;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            StartTimeWorkTimer(item) {
                this.$http
                    .get(
                        "WorkTimer/StartTime?id=" +
                        item.id
                    )
                    .then((data) => {
                        if (data.data.isSuccess) {
                            clearInterval(this.polling)
                            this.$store.dispatch("GetWorkTimerListFromServer", {
								status: this.filterId,
								text: this.searchKey,
								date: this.date,
								projectId: this.projectId,
								userId: this.userId,
								page: this.page
                            });

                        } else {
                            this.showErrorMessage(data.data.message);
                        }
                    })
            },
            StopTimeWorkTimer(item) {
                this.$http
                    .get(
                        "WorkTimer/StopTime?id=" +
                        item.id
                    )
                    .then((data) => {
                        if (data.data.isSuccess) {
                            clearInterval(this.polling);
                            this.$store.dispatch("GetWorkTimerListFromServer", {
								status: this.filterId,
								text: this.searchKey,
								date: this.date,
								projectId: this.projectId,
								userId: this.userId,
								page: this.page
                            });
                        } else {
                            this.showErrorMessage(data.data.message);
                        }
                    })
            },
            DeleteWorkTimer() {
                document.getElementsByClassName('menu-hider')[0].click();
                VueSimpleAlert.confirm("آیا مایل به حذف این مورد هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http
                        .get(
                            "WorkTimer/Delete?id=" +
                            this.itemId
                        )
                        .then((data) => {
                            if (data.data.isSuccess) {
                                clearInterval(this.polling)
                                this.$store.dispatch("GetWorkTimerListFromServer", {
									status: this.filterId,
									text: this.searchKey,
									date: this.date,
									projectId: this.projectId,
									userId: this.userId,
									page: this.page
                                });
                            } else {
                                this.showErrorMessage(data.data.message);
                            }
                        })
                });
            },
            RegistWorkTimer() {
                document.getElementsByClassName('menu-hider')[0].click();
                VueSimpleAlert.confirm("آیا مایل به اتمام این مورد هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    //Regist
                    this.$http
                        .get(
                            "WorkTimer/Regist?id=" +
                            this.itemId
                        )
                        .then((data) => {
                            if (data.data.isSuccess) {
                                clearInterval(this.polling)
                                this.$store.dispatch("GetWorkTimerListFromServer", {
									status: this.filterId,
									text: this.searchKey,
									date: this.date,
									projectId: this.projectId,
									userId: this.userId,
									page: this.page
                                });
                            } else {
                                this.showErrorMessage(data.data.message);
                            }
                        })
                });
            },
            WorkTimerInsertOtherWork() {
                document.getElementsByClassName('menu-hider')[0].click();
                this.openCreateOtherWorkModal = true;
            },
            GetDatediffBetweenTheseTwoTimes(item) {
                this.$http
                    .get(
                        "WorkTimer/GetDatediffBetweenTheseTwoTimes?startDate=" +
                        item.startDateTime
                    )
                    .then((data) => {
                        document.getElementById("TimeCunter").innerText = data.data;
                        clearInterval(this.polling);
                        this.polling = setInterval(function () {
                            let h = 0;
                            let m = 0;
                            let s = 0;
                            let time = [];
                            let t = document.getElementById("TimeCunter");
                            time = t.innerText.split(":");
                            h = parseInt(time[0])
                            m = parseInt(time[1])
                            s = parseInt(time[2])
                            s = s + 1;
                            if (s >= 60) {
                                s = 0;
                                m = m + 1;
                            }
                            if (m >= 60) {
                                m = 0;
                                h = h + 1;
                            }
                            t.innerText = h.toString().padStart(2, '0') + ":" + m.toString().padStart(2, '0') + ":" + s.toString().padStart(2, '0');
                        }, 1000);
                    });
            }
        }

    };
</script>
